import { ConversationListResponse, InboxAccountListResponse, MessageListResponse, MessageSummarySchema, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * Os números da loja, para o seletor do inbox (F091).
 *
 * NÃO é `fetchChannelAccounts`: aquela pede `communication.channel.read`, que
 * um caixa ou vendedor não tem. Esta pede a mesma permissão de ler a conversa.
 * Ver a rota `/communication/inbox/accounts` para a explicação inteira.
 */
export const fetchInboxAccounts = async (signal) => InboxAccountListResponse.parse(await request('/api/v1/communication/inbox/accounts', { signal })).accounts;
export const fetchConversations = async (query, signal) => {
    const params = new URLSearchParams();
    params.set('limit', String(query.limit));
    params.set('offset', String(query.offset));
    // Vazio não vai: `search=` no querystring é um termo de busca vazio, e o
    // servidor teria de adivinhar que isso significa "sem busca".
    if (query.search !== undefined && query.search.trim() !== '') {
        params.set('search', query.search.trim());
    }
    if (query.filter !== undefined)
        params.set('filter', query.filter);
    if (query.accountId !== undefined)
        params.set('accountId', query.accountId);
    if (query.assignee !== undefined)
        params.set('assignee', query.assignee);
    return ConversationListResponse.parse(await request(`/api/v1/communication/conversations?${params.toString()}`, {
        signal,
    }));
};
/**
 * "Eu li isto" (F084) — zera o contador de não lidas.
 *
 * Sem resposta para conferir: o servidor devolve 204. Falhar aqui não pode
 * atrapalhar quem está lendo a conversa, então quem chama ignora o erro em vez
 * de mostrar um alerta sobre um contador.
 */
export const markConversationRead = async (conversationId) => {
    await request(`/api/v1/communication/conversations/${conversationId}/read`, {
        method: 'POST',
    });
};
export const fetchMessages = async (conversationId, query, signal) => {
    const params = new URLSearchParams();
    params.set('limit', String(query.limit));
    params.set('offset', String(query.offset));
    return MessageListResponse.parse(await request(`/api/v1/communication/conversations/${conversationId}/messages?${params.toString()}`, { signal }));
};
/**
 * Manda uma imagem na conversa (03/10): o print colado, o anexo ou o arquivo
 * arrastado. A legenda vai ANTES do arquivo no formulário — o servidor lê os
 * campos que chegaram até o arquivo. `FormData` sem `Content-Type` à mão.
 */
export const sendConversationImage = async (conversationId, input) => {
    const form = new FormData();
    if (input.caption.trim() !== '')
        form.append('caption', input.caption.trim());
    // Antes do arquivo, como a legenda: o servidor lê os campos que vieram antes.
    if (input.id !== undefined)
        form.append('id', input.id);
    form.append('file', input.file);
    return MessageSummarySchema.parse(await request(`/api/v1/communication/conversations/${conversationId}/messages/image`, { method: 'POST', body: form }));
};
/**
 * Responde uma conversa. O prefixo `*Nome:*` é aplicado pelo servidor, com o
 * nome de quem está logado — não algo que este cliente monta.
 */
export const sendConversationMessage = async (conversationId, input) => MessageSummarySchema.parse(await request(`/api/v1/communication/conversations/${conversationId}/messages`, { method: 'POST', body: input }));
//# sourceMappingURL=communication-conversations.js.map